import React, { FunctionComponent } from 'react';
import styles from './Recruitment.module.scss';
import { Block, BlockHeader, RecruitmentTile, BlockContent, Link, Typography } from 'components/elements';
import { WPAcfRecruitment } from 'types/acf/recruitment';

interface OwnProps {
  data: WPAcfRecruitment | null;
}

type RecruitmentProps = JSX.IntrinsicElements['div'] & OwnProps;

const Recruitment: FunctionComponent<RecruitmentProps> = props => {
  const { data } = props;

  if (!data) {
    return null;
  }

  const { items, header, buttonLabel, buttonLink, note } = data;

  return (
    <Block id="recruitment" className={styles.wrapper} data-module="recruitment">
      <BlockContent className={styles.container}>
        <BlockHeader>{header}</BlockHeader>
        <div className={styles.content}>
          {items && items.map(item => <RecruitmentTile data={item} key={item.position} />)}
          {buttonLabel && buttonLink && note && (
            <div className={styles.footer}>
              <Typography className={styles.label} mobile="neue_semibold_16" tablet="neue_semibold_16" desktop="neue_semibold_20" as="h2">
                {note}
              </Typography>
              <Link href={buttonLink}>{buttonLabel}</Link>
            </div>
          )}
        </div>
      </BlockContent>
    </Block>
  );
};

export default Recruitment;
